<template>
  <div>
    <div class="fm-view-img">
      <video
          v-if="info.ext === 'mp4'"
          style="border-radius: 0.357rem;width: 100%;max-height: 180px"
          controls
      >
        <source :src="info.url">
      </video>
      <fm-file-preview v-else :file="file" style="border-radius: 8px" />
    </div>
    <div class="fm-view-content">
      <b-row class="mb-1">
        <b-col md=4>نام فایل</b-col>
        <b-col class="font-sans" v-text="info.name" />
      </b-row>
      <b-row class="mb-1">
        <b-col md=4>فرمت</b-col>
        <b-col class="font-sans" v-text="info.ext" />
      </b-row>
      <b-row class="mb-1">
        <b-col md=4>تاریخ ایجاد</b-col>
        <b-col class="font-sans" v-text="info.date" />
      </b-row>
      <b-row class="mb-1">
        <b-col md=4>حجم</b-col>
        <b-col class="font-sans" v-text="info.size" />
      </b-row>
      <b-row>
        <b-col md=4>لینک</b-col>
        <b-col class="font-sans d-flex flex-nowrap">
          <feather-icon icon="ExternalLinkIcon" style="margin-left: 5px;min-width: 20px;margin-top: 5px" />
          <a :href="info.url" v-text="info.url" target="_blank" style="word-break: break-all" />
        </b-col>
      </b-row>
    </div>
    <div class="d-flex mt-1">
      <b-button
          v-if="selectable"
          v-ripple.400="'rgba(186, 191, 199, 0.15)'"
          variant="outline-primary"
          class="flex-grow-1 mr-1"
          @click="$emit('select')"
      >
        انتخاب
      </b-button>
      <b-button
          v-if="editable"
          v-ripple.400="'rgba(255, 255, 255, 0.15)'"
          type="submit"
          variant="outline-danger"
          class="flex-grow-1"
          @click="$emit('delete')"
      >
        حذف
      </b-button>
    </div>
  </div>
</template>

<script>
import FmFilePreview from "@/views/menu/file-manager/components/fmFilePreview.vue";

export default {
  name: "fmFileView",
  components: { FmFilePreview },
  props: {
    file: { type: Object, default: null },
    selectable: { type: Boolean, default: true },
    editable: { type: Boolean, default: true },
  },
  computed: {
    info() {
      return {
        name: this.file.Name.split('.')[0],
        ext: this.file.Extension.replace('.', ''),
        date: this.$moment(this.file.CreatAt).format('jYYYY-jMM-jDD'),
        size: this.file.Size,
        url: this.file.Path
      }
    }
  }
}
</script>